import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  button: {
    borderRadius: 50,
    justifyContent: 'center',
    display: 'flex',
    flex: 1,
  },
  buttonInner: {
    height: '100%',
    width: '100%',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  buttonHover: {},
  buttonPressed: {},
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
  buttonDisabled: {
    cursor: 'not-allowed',
  },
  buttonFill: {
    borderWidth: 2,
    borderColor: 'transparent',
    backgroundColor: neutrals.white,
    ...getBoxShadow({
      offsetX: 1,
      offsetY: 1,
      blurRadius: 6,
      opacity: 0.15,
      color: neutrals.black,
    }),
  },
  buttonOutlined: {
    borderWidth: 2,
    borderColor: 'transparent',
    ...getBoxShadow({
      offsetX: 3,
      offsetY: 3,
      blurRadius: 8,
      opacity: 0.1,
      color: neutrals.black,
    }),
  },
  buttonOnlyIcon: {
    borderWidth: 2,
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    ...getBoxShadow('none'),
  },
  buttonExtrasmallFill: {
    width: 22.28,
    minWidth: 22.28,
    maxWidth: 22.28,
    height: 22.28,
    minHeight: 22.28,
    maxHeight: 22.28,
  },
  buttonExtrasmallOutlined: {
    width: 22.1,
    minWidth: 22.1,
    maxWidth: 22.1,
    height: 22.1,
    minHeight: 22.1,
    maxHeight: 22.1,
  },
  buttonExtrasmallOnlyIcon: {
    width: 22.28,
    minWidth: 22.28,
    maxWidth: 22.28,
    height: 22.28,
    minHeight: 22.28,
    maxHeight: 22.28,
  },
  buttonSmallFill: {
    width: 24,
    minWidth: 24,
    maxWidth: 24,
    height: 24,
    minHeight: 24,
    maxHeight: 24,
  },
  buttonSmallOutlined: {
    width: 24,
    minWidth: 24,
    maxWidth: 24,
    height: 24,
    minHeight: 24,
    maxHeight: 24,
  },
  buttonSmallOnlyIcon: {
    width: 24,
    minWidth: 24,
    maxWidth: 24,
    height: 24,
    minHeight: 24,
    maxHeight: 24,
  },
  buttonMediumFill: {
    width: 30,
    minWidth: 30,
    maxWidth: 30,
    height: 30,
    minHeight: 30,
    maxHeight: 30,
  },
  buttonMediumOutlined: {
    width: 30,
    minWidth: 30,
    maxWidth: 30,
    height: 30,
    minHeight: 30,
    maxHeight: 30,
  },
  buttonMediumOnlyIcon: {
    width: 30,
    minWidth: 30,
    maxWidth: 30,
    height: 30,
    minHeight: 30,
    maxHeight: 30,
  },
  buttonLargeFill: {
    width: 38,
    minWidth: 38,
    maxWidth: 38,
    height: 38,
    minHeight: 38,
    maxHeight: 38,
  },
  buttonLargeOutlined: {
    width: 38,
    minWidth: 38,
    maxWidth: 38,
    height: 38,
    minHeight: 38,
    maxHeight: 38,
  },
  buttonLargeOnlyIcon: {
    width: 38,
    minWidth: 38,
    maxWidth: 38,
    height: 38,
    minHeight: 38,
    maxHeight: 38,
  },
  buttonLargeCozyFill: {
    width: 38,
    minWidth: 38,
    maxWidth: 38,
    height: 38,
    minHeight: 38,
    maxHeight: 38,
  },
  buttonLargeCozyOutlined: {
    width: 38,
    minWidth: 38,
    maxWidth: 38,
    height: 38,
    minHeight: 38,
    maxHeight: 38,
  },
  buttonLargeCozyOnlyIcon: {
    width: 38,
    minWidth: 38,
    maxWidth: 38,
    height: 38,
    minHeight: 38,
    maxHeight: 38,
  },
  buttonExtralargeFill: {
    width: 50,
    minWidth: 50,
    maxWidth: 50,
    height: 50,
    minHeight: 50,
    maxHeight: 50,
  },
  buttonExtralargeOutlined: {
    width: 50,
    minWidth: 50,
    maxWidth: 50,
    height: 50,
    minHeight: 50,
    maxHeight: 50,
    borderWidth: 3,
  },
  buttonExtralargeOnlyIcon: {
    width: 50,
    minWidth: 50,
    maxWidth: 50,
    height: 50,
    minHeight: 50,
    maxHeight: 50,
  },
  icon: {
    color: brand.main.water,
  },
  iconHover: {},
  iconPressed: {},
  iconFocus: {},
  iconDisabled: {
    opacity: 0.5,
  },
  iconFill: {},
  iconOutlined: {},
  iconOnlyIcon: {
    backgroundColor: 'transparent',
    ...getBoxShadow('none'),
  },
  iconExtrasmallFill: {
    width: 12.09,
    height: 12.09,
  },
  iconExtrasmallOutlined: {
    width: 11.91,
    height: 11.91,
  },
  iconExtrasmallOnlyIcon: {
    width: 12.09,
    height: 12.09,
  },
  iconSmallFill: {
    width: 13.78,
    height: 13.78,
  },
  iconSmallOutlined: {
    width: 13.78,
    height: 13.78,
  },
  iconSmallOnlyIcon: {
    width: 13.78,
    height: 13.78,
  },
  iconMediumFill: {
    width: 13.78,
    height: 13.78,
  },
  iconMediumOutlined: {
    width: 13.78,
    height: 13.78,
  },
  iconMediumOnlyIcon: {
    width: 17.72,
    height: 17.72,
  },
  iconLargeFill: {
    width: 17.72,
    height: 17.72,
  },
  iconLargeOutlined: {
    width: 16.73,
    height: 16.73,
  },
  iconLargeOnlyIcon: {
    width: 25.59,
    height: 25.59,
  },
  iconLargeCozyFill: {
    width: 13.78,
    height: 13.78,
  },
  iconLargeCozyOutlined: {
    width: 13.78,
    height: 13.78,
  },
  iconLargeCozyOnlyIcon: {
    width: 23.62,
    height: 23.62,
  },
  iconExtralargeFill: {
    width: 19.69,
    height: 19.69,
  },
  iconExtralargeOutlined: {
    width: 19.69,
    height: 19.69,
  },
  iconExtralargeOnlyIcon: {
    width: 29.53,
    height: 29.53,
  },
});
